import { defer } from 'lodash-es'
import {
  memo,
  useEffect,
  useRef,
} from 'react'
import { scrollToElement, scrollToTop } from 'd2/utils/ScrollTo'
import { useLocation } from 'd2/hooks/useRouter'
import type { BrowserLocation } from 'd2/types'

// TODO: move to d2/src/hooks
export function useScrollToTopOnChangePath () {
  const location: BrowserLocation = useLocation()
  const hashRef = useRef<string | null>(location.hash)
  hashRef.current = location.hash

  useEffect(() => () => {
    defer(() => {
      // If there's a `location.hash` present, it means we are trying to scroll the page to a specific named anchor.
      // In that case, we don't want to scroll the page to the top.
      // Scroll to the element with the name of the location.hash instead!

      if (hashRef.current) {
        // slice the '#' off the hash
        const name = hashRef.current.slice(1)
        // linkedom doesn't define `document.getElementsByName` so I'm using querySelector here instead.
        // NOTE: `document.querySelector` seems to always return null when using jest/linkedom...
        const element = document.querySelector(`[name="${name}"]`)
        if (element) {
          // NOTE: Ideally, this would work even if the page transition has to wait for a moment for data loading.
          // Maybe there's a way to register a callback to scroll to the element once it's ready?
          // E.g. after all useQuery have resolved?
          scrollToElement(element)
        }
      } else {
        scrollToTop()
      }
    })
  }, [location.pathname, location.hash])
}

const ScrollToTopOnChangePath = memo<EO>(() => {
  useScrollToTopOnChangePath()

  return null
})

ScrollToTopOnChangePath.displayName = 'ScrollToTopOnChangePath'

export default ScrollToTopOnChangePath
